import {View} from "./View"
export const BrandingLink =  ()=> {
    return(
        <View />
    )
}
